export enum Wallet {
  MetaMask = 'metamask',
  Coinbase = 'coinbase',
  Rainbow = 'rainbow',
  WalletConnect = 'walletconnect',
  Brave = 'brave',
  Opera = 'opera',
}
